import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      const response = await fetch(
        'https://script.google.com/macros/s/AKfycbwQ3LKoGkYGMiPyKsk05T6D6LEWt7k8njAJ_BCTyyEXYEq6BI_NqzjBd1Xhghw9L4Urcg/exec?placeId=.;vbvnvvccbncbncvcfccvcvcvhmcvcnbvbvbvcnjvcjbhhfhnvmvnvcbcv nc m cx    cxnmx   cvb njc  ncnm nxcc cbnd  jndnvvbnjjvghrndfxvbfbnvbbmdhkjcedlwhhrjdfvhsdf gfjekhrfjehrfikrgftrolkrihyggfhhughgrofoyrgot3pro-fp7ohtoirtituiy6ooi7bvbv='
      );
      const data = await response.json();
      const reviewsData = data.result?.reviews || [];

      setReviews(reviewsData);
    };
    fetchReviews();
  }, []);
  const averageRating = (
    reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length
  ).toFixed(1);
  return (
    <div id="opinie" className=" bg-gray-800 p-6 fade-in ">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-semibold mb-4">Opinie</h2>

        <div className="bg-gray-800 p-4 rounded-xl text-center mb-6">
          <p className="text-xl font-bold">{averageRating}</p>
          <p className="text-yellow-400 text-lg">★★★★★ ({reviews.length})</p>
        </div>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          navigation
          pagination={{ clickable: true }}
          modules={[Navigation, Pagination]}
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="bg-gray-700 rounded-2xl p-4 h-full flex flex-col justify-between">
                <div>
                  <p className="text-yellow-400 mb-2">★★★★★</p>
                  <p className="text-sm mb-3">
                    {review.text.length > 100
                      ? review.text.slice(0, 100) + '...'
                      : review.text}
                  </p>
                  {/* {review.text.length > 100 && (
                    <span className="text-blue-400 text-sm cursor-pointer">
                      Czytaj więcej..
                    </span>
                  )} */}
                </div>
                <div className="flex items-center gap-3 mt-4">
                  <img
                    src={review.profile_photo_url}
                    alt={review.author_name}
                    className="w-10 h-10 rounded-full"
                  />
                  <div>
                    <p className="font-semibold">{review.author_name}</p>
                    <p className="text-xs text-gray-300">
                      {review.relative_time_description}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Reviews;
